import { IsOptional, IsString, IsUUID, MaxLength, MinLength } from 'class-validator';

/**
 * Body for `POST /admin/iot/gateways` — platform-admin provisioning.
 *
 * `deviceId` = 12-char hex of base MAC. The endpoint is an upsert keyed on
 * deviceId: re-POST rotates the password and updates the tenant assignment
 * (with cascade to sensors — see IotService). Response always includes a new
 * plaintext `password` and the public `mqttHost`.
 */
export class CreateIotGatewayDto {
  @IsString()
  @MinLength(12)
  @MaxLength(12)
  deviceId!: string;

  @IsUUID()
  tenantId!: string;

  @IsOptional()
  @IsString()
  @MaxLength(120)
  name?: string;
}
